import _assign from "object-assign";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useContext } from 'react';
import classNames from 'classnames';
import { useDensity, withStyles } from '@jpmuitk/theme';
import PropTypes from 'prop-types';
import AdornmentContext from './internal/AdornmentContext';
import { staticAdornmentStyle } from './style';
var StaticInputAdornment = /*#__PURE__*/React.forwardRef(function StaticInputAdornment(props, ref) {
  var _classNames;

  var _useContext = useContext(AdornmentContext),
      suffix = _useContext.suffix,
      prefix = _useContext.prefix;

  var classes = props.classes,
      className = props.className,
      children = props.children,
      densityProp = props.density,
      isCE = props.isCE,
      other = _objectWithoutProperties(props, ["classes", "className", "children", "density", "isCE"]);

  var density = useDensity(densityProp);
  return /*#__PURE__*/React.createElement("div", _assign({
    className: classNames(className, classes.root, (_classNames = {}, _defineProperty(_classNames, classes["".concat(density, "Density")], !isCE), _defineProperty(_classNames, classes.prefix, prefix), _defineProperty(_classNames, classes.suffix, suffix), _classNames)),
    ref: ref
  }, other), children);
});
export default withStyles(staticAdornmentStyle, {
  name: 'StaticInputAdornment'
})(StaticInputAdornment);
process.env.NODE_ENV !== "production" ? StaticInputAdornment.propTypes = {
  /**
   * An Icon or a string.
   */
  children: PropTypes.node,

  /**
   * The className(s) of the component
   */
  className: PropTypes.string,

  /**
   * material-ui
   * Useful to extend the style applied to components.
   */
  classes: PropTypes.objectOf(PropTypes.string),

  /**
   * Determines the density of the component.
   */
  density: PropTypes.oneOf(['touch', 'low', 'medium', 'high']),

  /**
   * @ignore - this is used by `custom element` only.
   * This removes styling from the React component and allows it to be set on the custom element container.
   */
  isCE: PropTypes.bool
} : void 0;